import { useEffect } from "react";
import Section from "../../../../components/base/Section";
import LiveCallsBoard from "../../../../components/calls/LiveCallsBoard";
import { setPage } from "../../../../core/Global";


export default function LiveCallsView() {

    useEffect(() => {
        setPage("Live Calls", "Voice");
    }, []);

    return (
        <Section fluid>
            <div className="row mt-3">
                <div className="col-12">
                    <LiveCallsBoard />
                </div>
            </div>
        </Section>
    );
}
